{
  "name": "04 Cherry Bonus",
  "title": "ScoreMultiplier",
  "description": "ScoreMultiplierUpgradeDescription1",
  "stat": 13,
  "lockFlag": 22
}